<script>
import axios from "axios";
import Badge from "@/views/kit/elements/Badge.vue";

export default {
  components: {Badge},
  data() {
    return {
      // Итоговые статусы принтеров
      statusMap: {
        online: {
          title: 'Онлайн',
          color: '#7fb55b'
        },
        problems: {
          title: 'Криты',
          color: '#ff0000'
        },
        offline: {
          title: 'Оффлайн',
          color: '#a979fe'
        },
        service: {
          title: 'Требуется обслуживание',
          color: '#f87800'
        },
        sleeping: {
          title: 'Спят',
          color: '#0070e8'
        }
      },
      stats: {
        online: 0,
        offline: 0,
        problems: 0,
        service: 0,
        sleeping: 0,
      },
      total: 0,
      printers: [],

      // Модалка
      showModal: false,
      currentStatus: 'online',
      selectedPrinters: '',
      modalTitle: '',

      // Таблица и паджинация
      currentPage: 1,
      perPage: 5,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,

      // Сервисные статусы:
      statuses: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    getFields() {
      // суть - динамиечский набор колонок, поле ошибки только для service и error
      // (критические ошибки, требуют обслуживания)
      return [].concat([
            {
              label: "Статус",
              key: "status",
              sortable: false
            },
            {
              label: "Адрес",
              key: "address",
              sortable: true
            },
            {
              label: "Код",
              key: "code",
              sortable: true
            },
          ], ['problems', 'service'].includes(this.currentStatus) ? [{
            label: "Ошибки",
            key: "errors",
            thStyle: { width: "50%" },
            formatter: (value, key, item) => {
              return [...item.warnings, ...item.errors].join('; ')
            },
            sortable: true
          }] : [],
          [
            {
              label: "⚙",
              key: "actions",
              thStyle: { width: "40px", alignSelf: "right" }
            }
          ]);
    },
    async setStatus(item, status) {
      item.service_status = status;
      await axios.post('/v1/printers/set-service-status', {
        'printerId': item.id,
        'serviceStatus': status,
      });
    },
    async sync(item) {
      let columnCode = 'offline';
      switch (this.currentStatus) {
        case 'online':
          columnCode = 'defects';
          break;
        case 'offline':
          columnCode = 'offline';
          break;
        case 'problems':
          columnCode = 'error';
          break;
        case 'service':
          columnCode = 'warning';
          break;
        case 'sleeping':
          columnCode = 'sleep';
          break;
      }
      try {
        const response = await axios.post('/v1/printers/sync', {
          'printerId': item.id,
          'columnCode': columnCode,
        });
        if (response.data.status === 'fail') {
          this.$store.dispatch('addNotification', {
            text: 'Ошибка интеграции с YouGile, проверьте токен и доступность API',
            time: 6,
            color: "danger"
          });
        } else {
          item.synced = true;
        }
      } catch (err) {
        this.$store.dispatch('addNotification', {
          text: err.message,
          time: 6,
          color: "danger"
        });
      }
    },

    updatePrinterStatuses(printer) {
      const hasErrors = printer.errors.length > 0;
      const hasWarnings = printer.warnings.length > 0;
      printer.statuses = [];

      if (hasErrors) {
        this.stats.problems++;
        printer.statuses.push('problems');
      }

      if (hasWarnings && !hasErrors) {
        this.stats.service++;
        printer.statuses.push('service');
      }

      if (!printer.online) {
        this.stats.offline++;
        printer.statuses.push('offline');
      }

      if (printer.online) {
        this.stats.online++;
        printer.statuses.push('online');
      }

      if (printer.sleeping) {
        this.stats.sleeping++;
        printer.statuses.push('sleeping');
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    openModal(statusKey) {
      this.currentStatus = statusKey;
      this.modalTitle = this.statusMap[statusKey].title;
      this.selectedPrinters = this.printers.filter(printer => printer.statuses.includes(statusKey));
      this.showModal = true;
      this.currentPage = 1;
      this.perPage = 5;
    },
    calcPercentage(value) {
      return Math.floor(value / this.total * 100);
    },

    async fetchData() {
      try {
        this.statuses = (await axios.post('/v1/printers/service-statuses')).data || [];
        const response = await axios.post('/v1/printers/map-get-all');
        this.printers = response.data || [];
      } catch (error) {
        console.error('Ошибка  получения принтеров:', error.message);
        this.printers = [];
      }

      this.total = this.printers.length;
      this.printers.forEach(printer => this.updatePrinterStatuses(printer));
    }
  }
};
</script>

<template>
  <div class="row grid grid-cols-5 grid-cols-subgrid">

    <div v-for="(value, key) in stats" :key="key" class="col mb-3">
      <div class="card bg-white h-100">
        <div class="card-body text-center p-2">
          <div class="text-primary mb-2">
            <div class="rounded-circle p-2 d-inline-block" :style="{backgroundColor: statusMap[key].color}"></div>
          </div>
          <h5 class="card-title">{{ statusMap[key].title }}</h5>
          <p class="display-4">{{ value }}</p>
          <p class="display-6">{{ calcPercentage(value) }} %</p>

          <b-button
              variant="primary"
              :disabled="value === 0"
              class="w-100 mt-3 py-2"
              @click="openModal(key)">
            Подробнее
          </b-button>
        </div>
      </div>
    </div>

    <b-modal v-model="showModal" :title="modalTitle" centered modal-class="custom-modal-width">
      <div class="table-responsive mb-0">
        <b-pagination
            v-model="currentPage"
            :total-rows="selectedPrinters.length"
            :per-page="perPage"
            aria-controls="printers-table"
            align="center"
            class="mt-3"
        ></b-pagination>

        <b-table
            :items="selectedPrinters"
            :fields="getFields()"
            responsive="xl"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
        >
          <template #cell(status)="row">
            {{ row.item.synced ? 'y' : '' }}&nbsp;<Badge v-if="row.item.service_status && statuses[row.item.service_status]"
                :title="statuses[row.item.service_status].title"
                :color="statuses[row.item.service_status].color"
              />
          </template>

          <template #cell(errors)="row">
            <ul class="list-unstyled mb-0">
              <li v-for="(warning, idx) in row.item.warnings" :key="'warn-'+idx">
                ⚠️ {{ warning }}
              </li>
              <li v-for="(error, idx) in row.item.errors" :key="'err-'+idx">
                ❌ {{ error }}
              </li>
            </ul>
          </template>
          <!-- Custom slot for the actions field -->
          <template #cell(actions)="row">
            <b-dropdown
                variant="link"
                toggle-class="text-decoration-none p-0"
                no-caret
                right
                @show="row.toggleDetails"
            >
              <template #button-content>
                <i class="ri-more-line"></i>
              </template>
              <b-dropdown-item v-if="!row.item.synced" @click="sync(row.item)">⇄ YouGile</b-dropdown-item>
              <b-dropdown-item v-for="(status, key) in statuses" :key="key" @click="setStatus(row.item, key)">
                <Badge :title="status.title" :color="status.color" />
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>
      </div>

      <template #modal-footer>
        <b-button variant="secondary" @click="showModal = false">Закрыть</b-button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.card {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.card-title {
  min-height: 30px;
  vertical-align: middle;
}

.display-4 {
  font-size: 1.5rem;
  font-weight: 300;
}

.display-6 {
  font-size: 1rem;
  font-weight: 100;
}

::v-deep .custom-modal-width .modal-dialog {
  max-width: 1140px !important;
  width: 90vw !important;
}
</style>